import { LOGO_URL } from "@/lib/api";
import { VslPlayer } from "@/components/landing/VslPlayer";
import { CtaButton, Kicker } from "@/components/landing/ui";
import { Star, Tv, Newspaper, Hammer } from "lucide-react";

export const LandingHeader = () => (
  <header className="border-b border-gray-100" data-testid="landing-header">
    <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between gap-4">
      <img src={LOGO_URL} alt="ARK Furniture" className="h-11 w-auto" />
      <p className="text-[10px] sm:text-[11px] uppercase tracking-[0.22em] text-gray-500 text-right">
        ARK Furniture Revival <span className="text-[#c19a6b] mx-1">·</span> Serving the GTA
      </p>
    </div>
  </header>
);

export const Hero = ({ landing }) => (
  <section className="max-w-6xl mx-auto px-6 pt-12 sm:pt-16 lg:pt-24 pb-16 lg:pb-28" data-testid="hero">
    <div className="grid lg:grid-cols-12 gap-x-14 gap-y-10 items-start">
      <div className="lg:col-span-7 lg:col-start-1 lg:row-start-1">
        <Kicker>ARK Furniture Revival</Kicker>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]" data-testid="hero-headline">
          Love your furniture.
          <br />
          <span className="text-gray-500">Hate how worn it looks?</span>
        </h1>
      </div>
      <div className="lg:col-span-5 lg:col-start-8 lg:row-start-1 lg:row-span-2 lg:pt-2">
        <VslPlayer vsl={landing?.vsl} posterId={landing?.vsl_poster_id} fallbackPhotoId={landing?.gallery?.[0]?.after_photo_id} />
      </div>
      <div className="lg:col-span-7 lg:col-start-1 lg:row-start-2 max-w-xl">
        <p className="text-lg sm:text-xl text-gray-800 leading-relaxed">
          If you still love the colour, character and quality of your furniture, you may not need to replace it — or completely restore it.
        </p>
        <p className="text-base text-gray-600 leading-relaxed mt-5">
          ARK Furniture Revival renews and protects the existing finish while preserving what you already love about the piece.
        </p>
        <div className="mt-10">
          <CtaButton testId="hero-cta" className="w-full sm:w-auto" />
          <p className="text-xs text-gray-500 mt-4 leading-relaxed tracking-wide">
            Quick qualification <span className="text-[#c19a6b] mx-1">·</span> No obligation <span className="text-[#c19a6b] mx-1">·</span> We'll tell you if Revival isn't the right service
          </p>
        </div>
      </div>
    </div>
  </section>
);

const CRED = [
  { icon: <span className="flex text-[#c19a6b]">{[0, 1, 2, 3, 4].map((i) => <Star key={i} size={13} fill="currentColor" />)}</span>, text: "Highly Rated by Customers" },
  { icon: <Tv size={16} className="text-[#c19a6b]" />, text: "Featured on The Marilyn Denis Show" },
  { icon: <Newspaper size={16} className="text-[#c19a6b]" />, text: "Featured in the National Post" },
  { icon: <Hammer size={16} className="text-[#c19a6b]" />, text: "Professional Workshop Finishing" },
];

export const CredibilityStrip = () => (
  <section className="border-y border-gray-200 bg-[#FAF7F2]" data-testid="credibility-strip">
    <div className="max-w-6xl mx-auto px-6 py-6 grid grid-cols-2 lg:grid-cols-4 gap-y-5 gap-x-8">
      {CRED.map((c) => (
        <div key={c.text} className="flex items-center gap-3">
          {c.icon}
          <span className="text-[11px] sm:text-xs uppercase tracking-[0.14em] text-gray-700 font-semibold leading-tight">{c.text}</span>
        </div>
      ))}
    </div>
  </section>
);
